import React from 'react';
import { Link } from 'react-router-dom';
import { paths } from './path';
import './NotFound.scss';

export interface NotFoundProps {}

export const NotFound = (props: NotFoundProps) => (
    <div className="not-found-page">
        <div className="not-found-page__content">
            <div className="not-found-page__code">404</div>
            <h2 className="not-found-page__title">Page not found</h2>
            <p className="not-found-page__message">
                The page you’re looking for doesn’t exist or may have been moved.
            </p>
            <Link to={paths.public.root} className="btn btn-primary">
                Return to home
            </Link>
        </div>
    </div>
);
